export default __webpack_public_path__ + "static/media/sidebar_item_gray.61fc1d16.svg";